import { HttpResponse, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlApi } from '../../../utils/apiConfig';
@Injectable()
export class LicensesServiceService {


  constructor(private http: HttpClient) {
    
   }

  public getClientsLicenses(): Observable<any>{
    return this.http.get(urlApi+'/admin/licencas/clientes');
  }

  public setCredits(data: any): Observable<any>{
    return this.http.post(urlApi+'/admin/pagarme/addcredits', {creditsAdd: data.creditos});
  }

  public sendPedidoRenewClientes(data: Array<any>): Observable<any>{
    return this.http.post(urlApi+'/admin/pagarme/pedido', {licencas: data });
  }

  public sendPedidoRenovarClientesAdmin(data: any): Observable<any>{
    return this.http.patch(urlApi+'/admin/licencas/renovar', data);
  }

  public sendPeidoRenovarClientAdminCredits(data: any): Observable<any>{
    return this.http.patch(urlApi+'/admin/licencas/renovar/credits', data);
  }

  public sendPedidoBloquearClientesAdmin(idClient: number): Observable<any>{
    return this.http.patch(urlApi+'/admin/licencas/bloquear', {idcliente: idClient});
  }

  public sendPedidoRenovarCliente(client: any){
    return this.http.post(urlApi+'/admin/pagarme/pedido', {
      licencas: [
        {
          emailClient: client.email,
          quantidadeCanais: client.canais
        }
      ]
    } )
  }

  public sendRequestActivateRenewAuto(idCliente: number): Observable<any>{
    return this.http.patch(`${urlApi}/admin/billing/credits/recorrency-activate`, {idCliente})
  }

  public sendRequestInactivateRenewAuto(idCliente: number){
    return this.http.patch(`${urlApi}/admin/billing/credits/recorrency-desactivate`, {idCliente})
  }


}
